<template>
  <div>
    <v-select
      :options="statusOptions"
      v-model="status"
      :searchable="false"
      :clearable="false"
      :disabled="changeInProgress || readOnly"
      :reduce="status => status.value"
      :placeholder="$t('status.selectSatus')"
      label="text">
    </v-select>

    <d-button
      v-if="originalStatus !== status && !readOnly"
      class="ml-2 text-nowrap"
      @click.prevent="changeStatus">
      <template v-if="!changeInProgress">
        {{ $t('status.changeStatus') }}
      </template>
      <template v-if="changeInProgress">
        <div
          class="spinner-border spinner-border-sm"
          role="status"></div>
      </template>
    </d-button>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import Vue from 'vue';

export default {
  name: 'purchase-status',
  props: [
    'initialStatus',
    'deadlineIsSet',
    'readOnly'
  ],
  computed: {
    orderID () {
      return parseInt(this.$route.params.id, 10);
    },
    statusOptions () {
      return [
        {
          value: 'NEW',
          text: this.$t('purchase.newOrder')
        },
        {
          value: 'WAITING_PRODUCTS',
          text: this.$t('purchase.awaitingProducts')
        },
        {
          value: 'WAITING_PAYMENT',
          text: this.$t('purchase.awaitingPayment')
        }
      ];
    }
  },
  data () {
    return {
      status: '',
      originalStatus: '',
      changeInProgress: false
    };
  },
  watch: {
    initialStatus (newValue) {
      this.originalStatus = newValue;
      this.status = this.originalStatus;
    }
  },
  mounted () {
    this.originalStatus = this.initialStatus;
    this.status = this.originalStatus;
  },
  methods: {
    changeStatus () {
      this.changeInProgress = true;

      if (!this.deadlineIsSet && this.status === 'WAITING_PRODUCTS') {
        Vue.swal({
          title: this.$t('status.cannotChangePurchaseStatusTitle'),
          text: this.$t('status.cannotChangePurchaseStatusText'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok')
        });
        this.changeInProgress = false;
        return;
      }

      Vue.swal({
        title: this.$t('status.changeStatusConfirmTitle'),
        text: this.$t('status.changeStatusConfirmText'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('ui.yesChange'),
        cancelButtonText: this.$t('ui.cancel'),
      }).then((result) => {
        if (result.value) {
          FormUtils.submit({
            $http: this.$http,
            endpoint: '/purchases/change-status/' + this.orderID,
            formData: {
              status: this.status
            },
            successTitle: this.$t('status.changeStatusSuccessTitle'),
            successText: this.$t('status.changeStatusSuccessText'),
            errorTitle: this.$t('ui.errorOccured'),
            errorText: this.$t('status.changeStatusErrorText'),
            successAction: () => {
              this.changeInProgress = false;
              this.originalStatus = this.status;
              this.$bus.$emit('purchase-reload');
            },
            failAction: () => {
              this.changeInProgress = false;
            }
          });
        } else {
          this.status = this.originalStatus;
          this.changeInProgress = false;
        }
      });
    }
  }
};
</script>
